<template>
	{{ priceFormatted }}
</template>
<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
	defineProps<{
		price: number
		digits?: number
		minDigits?: number
		shorten?: boolean
	}>(),
	{
		shorten: false,
		digits: 2,
		minDigits: 0
	}
)

const priceFormatted = computed(() => {
	let value = props.price / 10 ** props.digits
	let suffix = ''

	if (props.shorten) {
		if (value >= 1_000_000) {
			value = value / 1_000_000
			suffix = 'kk'
		} else if (value >= 1_000) {
			value = value / 1_000
			suffix = 'k'
		}
	}

	const parts = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: props.minDigits,
		maximumFractionDigits: props.digits
	}).formatToParts(value)

	return (
		parts
			.filter(
				(part) =>
					part.type === 'integer' ||
					part.type === 'decimal' ||
					part.type === 'fraction' ||
					part.type === 'group'
			)
			.map((part) => part.value)
			.join('') + suffix
	)
})
</script>
